export const WrapTextIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '16'}
    height={props?.height || '16'}
    viewBox="0 0 24 24"
    fill="none"
    stroke={props?.color || 'currentColor'}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 6h18" />
    <path d="M3 12h15a3 3 0 0 1 0 6h-4" />
    <path d="M16 16l-2 2 2 2" />
    <path d="M3 18h7" />
  </svg>
);
